import React, { useRef, useEffect, useState } from "react";
import { motion, useScroll, useTransform, AnimatePresence } from "framer-motion";
import { GoogleGeminiEffect } from "../Components/Google-gemini-effect";
import "./HeroSection.css";
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll();
  const navigate = useNavigate();
  const [isExiting, setIsExiting] = useState(false);

  const pathLengthFirst = useTransform(scrollYProgress, [0, 0.8], [0.2, 1.2]);
  const pathLengthSecond = useTransform(scrollYProgress, [0, 0.8], [0.15, 1.2]);
  const pathLengthThird = useTransform(scrollYProgress, [0, 0.8], [0.1, 1.2]);
  const pathLengthFourth = useTransform(scrollYProgress, [0, 0.8], [0.05, 1.2]);
  const pathLengthFifth = useTransform(scrollYProgress, [0, 0.8], [0, 1.2]);

  useEffect(() => {
    document.body.style.overflow = 'visible';
    return () => {
      document.body.style.overflow = 'visible';
    };
  }, []);

  const handleStartApplication = () => {
    setIsExiting(true);
    setTimeout(() => {
      navigate('/start-application');
    }, 500); // Adjust this delay to match your animation duration
  };

  return (
    <AnimatePresence>
      {!isExiting && (
        <motion.div
          ref={containerRef}
          className="hero-container"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="hero-content">
            <h1 className="hero-title, font-philosopher text-7xl">Home Financing Portal</h1>
            <p className="hero-subtitle font-philosopher text-3xl">Thank you for choosing UIF Islamic Home Financing</p>
            <div className="hero-button-wrapper">
              <motion.button
                className="hero-button"
                onClick={handleStartApplication}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Start Your Application Now
            </motion.button>
          </div>
          </div>
          <GoogleGeminiEffect
            className="hero-background"
            pathLengths={[
              pathLengthFirst,
              pathLengthSecond,
              pathLengthThird,
              pathLengthFourth,
              pathLengthFifth,
            ]}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default HeroSection;
